export const iconFontAwesomeShoppingPaypal = (
	<i className="fa-solid fa-paypal"></i>
);
